import { lazy } from 'react';

const EthiopostRoutes = [
  {
    path: 'ethiopost-deliveries',
    component: lazy(() => import('views/ethiopost-deliveries')),
  },
  {
    path: 'ethiopost-deliveries/:id',
    component: lazy(() => import('views/ethiopost-deliveries/ethiopost-delivery-detail')),
  },
];

export default EthiopostRoutes;

